import { render, staticRenderFns } from "./HeaderManageIdpExamRegister.vue?vue&type=template&id=b49dd944&scoped=true"
import script from "./HeaderManageIdpExamRegister.vue?vue&type=script&lang=js"
export * from "./HeaderManageIdpExamRegister.vue?vue&type=script&lang=js"
import style0 from "./HeaderManageIdpExamRegister.vue?vue&type=style&index=0&id=b49dd944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49dd944",
  null
  
)

export default component.exports